import { Block } from "shared/model";
import { OriginSize } from "shared/origin";

export class LevelObject {
    public static x: number = 0;
    public static y: number = 0;
    public static columns: number = 7;
    public static rows: number = 7;
    public static scoreCounter: number = 3;
    public static mapWidth: number = (OriginSize.width * 0.9) / 7;
    public static mapHeight: number = (OriginSize.width * 0.9) / 7;
    public static tileWidth: number = (OriginSize.width * 0.8) / 7 + 10;
    public static tileHeight: number = (OriginSize.width * 0.8) / 7 + 10;
    public static tilesMargin: number = 16;
    public static tiles: any = [];
    public static emptyTile: number = -5;
    public static shufllTiles = [];
    public static shufllTilesDictionary = {};
    public static helpersBlocks: any[] = [];
    public static animations: any[] = [];
    public static productHeight: number = 3;
    public static selectedTile: { selected: boolean, map: number, 
        column: number, row: number, tile: Block } = { selected: false, map: null, column: 0, row: 0, tile: null };
}